"use client";
import t from "../common/hooks/useVisibilityMouseEvent.js";
const n = () => {
  const [e, o] = t({
    eventIn: "mouseover",
    eventOut: "mousedown"
  });
  return [e, o];
};
export {
  n as usePopup
};
